import facebook from './images/facebook.svg';
import instagram from './images/instagram.svg';
import linkedin from './images/linkedin.svg';
import youtube from './images/youtube.svg';

export const links = [
	//The first column of links...
	{
		name: 'EXPLORE',
		href: '/solutions/window-insulation',
		order: 'order-1',
		children: [
			{
				name: 'Products',
				href: '/products/indowone-window-inserts',
			},
			{
				name: 'Performance Data',
				href: '/performance',
			},
			{
				name: 'Featured Articles',
				href: '/resources/featured-articles',
			},
			{ name: 'Case Studies', href: '/resources/case-studies' },
			{ name: 'Large Projects', href: '/solutions/commercial-window-inserts' },
			{
				name: 'Historic Preservation',
				href: '/solutions/preserve-historic-windows',
			},
			{
				name: 'Contractor Program',
				href: '/about-indow/contractor-discount-program',
			},
			{ name: 'Indow Careers', href: '/about-indow/careers' },
		],
	},

	//The second column of links...
	{
		name: 'LEARN',
		href: '/how-to',
		order: 'order-4 md:order-2',
		children: [
			{
				name: 'About Indow',
				href: '/about-indow',
			},
			{ name: 'FAQ', href: '/resources/faq' },
			{
				name: 'Window Compatibility',
				href: '/guides/indow-window-compatibility',
			},
			{ name: 'Measure Guide', href: '/self-measure-instructions' },
			{
				name: 'Install Guide',
				href: '/how-to/install-window-inserts',
			},
			{
				name: 'How Inserts Work',
				href: '/how-to/insulate-your-home',
			},
		],
	},

	//The third column of links...
	{
		name: 'TRUST',
		href: '/about-indow',
		order: 'order-3',
		children: [
			{
				name: 'Residential Warranty',
				href: '/warranties/residential-lifetime-warranty',
			},
			{ name: 'Commercial Warranty', href: '/warranties/commercial-warranty' },
			{
				name: 'Snug Fit Guarantee',
				href: '/warranties/snug-fit-guarantee',
			},
			{ name: 'Noise Disclaimer', href: '/noise-disclaimer' },
			{ name: 'Terms of Sale', href: '/warranties/terms-of-sale' },
			{ name: 'Privacy Policy', href: '/privacy-policy' },
		],
	},

	//The fourth column of links...
	{
		name: 'CONNECT',
		href: '/about-indow/contact',
		order: 'order-2 md:order-4',
		children: [
			{ name: 'Contact Us', href: '/about-indow/contact' },
			{ name: 'Measure Support', href: '/measure-support' },
			{ name: 'File A Claim', href: '/claim-submission-customer' },
			{
				name: 'Get Estimate',
				href: '/free-estimate',
			},
			{
				name: 'Press & Media',
				href: '/about-indow/media',
			},
		],
	},
];

export const social = [
	{
		name: 'Facebook',
		href: 'https://www.facebook.com/indowwindows',
		img: facebook,
	},
	{
		name: 'LinkedIn',
		href: 'https://www.linkedin.com/company/indow-windows',
		img: linkedin,
	},
	{
		name: 'Instagram',
		href: 'https://www.instagram.com/indowwindows',
		img: instagram,
	},
	{
		name: 'Youtube',
		href: 'https://www.youtube.com/user/IndowWindows',
		img: youtube,
	},
];
